





































import Vue from 'vue'
import { mapGetters, mapMutations } from 'vuex'
import PaidBadge from '@/components/PaidLabel/PaidBadge.vue'
import { SidebarMutationTypes } from '@/store/modules/sidebar/mutations'
import { UserScope } from '@/models/users'
import { KnowledgeBase } from '@/models/knowledge'
import { MenuLinkItem, MenuButtonItem } from '@/models/menu'
import { isProduction } from '@/constants/enviroment'
import { EOpenSidebar } from '@/constants/sidebar'

interface Methods {
  [SidebarMutationTypes.ToggleSidebar]: (value: EOpenSidebar | false) => void
  toggleSettings: () => void
  toggleKnowledge: () => void
  closeAllSidebars: () => void
  handleClickRouteLink: () => void
}

interface Computed {
  canDoScope: (checkingScope: UserScope) => boolean
  openSidebar: EOpenSidebar | false
  companyIsPro: boolean
  knowledgeBases: KnowledgeBase[]
  logo: string
  menuLinkItems: MenuLinkItem[]
  menuButtonItems: MenuButtonItem<() => void, EOpenSidebar>[]
}

interface Props {
  isMobile: boolean
}

export default Vue.extend<{}, Methods, Computed, Props>({
  components: {
    PaidBadge,
  },
  props: {
    isMobile: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      canDoScope: 'canDoScope',
      openSidebar: 'getOpenSidebar',
      companyIsPro: 'getCompanyIsPro',
      knowledgeBases: 'getKnowledgeBases',
    }),
    logo(): string {
      return require(`@/assets/svg/${
        this.companyIsPro
          ? 'logo-foxgid-white-pro.svg'
          : 'logo-foxgid-white.svg'
      }`)
    },
    menuLinkItems(): MenuLinkItem[] {
      const menu = [
        // {
        //   label: 'Главная',
        //   route: '/dashboard',
        //   icon: 'home',
        // },
        // {
        {
          label: this.$tc('script.title', 2),
          route: '/scripts',
          icon: 'script',
          scope: UserScope.ScriptsView,
        },
        //   label: 'Аналитика',
        //   route: '/analytic',
        //   icon: 'analytics',
        //   scope: UserScope.Stats,
        // },
        // {
        //   label: this.$tc('billing.billing'),
        //   route: '/billing',
        //   icon: 'records-thin',
        //   scope: UserScope.Finance,
        // },
        {
          label: this.$tc('records.records'),
          route: '/records',
          icon: 'records-thin',
          scope: UserScope.Recordings,
          requiredPro: !this.companyIsPro,
        },
      ]

      if (!isProduction) {
        menu.push()
      }

      return menu.filter(item =>
        item.scope ? this.canDoScope(item.scope) : true,
      )
    },
    menuButtonItems(): MenuButtonItem<() => void, EOpenSidebar>[] {
      const knowledgeIsHidden =
        !this.knowledgeBases.length && !this.canDoScope(UserScope.KnowledgeEdit)

      return [
        {
          icon: 'knowledge',
          click: this.toggleKnowledge,
          active: EOpenSidebar.Knowledge,
          label: this.$tc('knowledge.title', 2),
          scope: UserScope.KnowledgeView,
          isHidden: knowledgeIsHidden,
        },
        {
          icon: 'settings',
          click: this.toggleSettings,
          active: EOpenSidebar.Settings,
          scope: UserScope.ScriptsView,
          isHidden: this.isMobile,
        },
      ].filter(item => {
        const canDoScope = item.scope ? this.canDoScope(item.scope) : true
        return !item.isHidden && canDoScope
      })
    },
  },
  methods: {
    ...mapMutations([SidebarMutationTypes.ToggleSidebar]),
    toggleSettings() {
      this[SidebarMutationTypes.ToggleSidebar](EOpenSidebar.Settings)
    },
    toggleKnowledge() {
      this[SidebarMutationTypes.ToggleSidebar](EOpenSidebar.Knowledge)
    },
    closeAllSidebars() {
      this[SidebarMutationTypes.ToggleSidebar](false)
    },
    handleClickRouteLink() {
      this.$emit('route-link-click')
    },
  },
})
